var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.location
    ? _c(
        "div",
        {
          staticClass: "order-box__location",
          class: {
            "order-box__location--no-click": _vm.noClick
          },
          on: {
            click: function($event) {
              _vm.noClick ? null : _vm.$emit("click")
            }
          }
        },
        [
          _vm.location.brand || _vm.location.image
            ? _c(
                "div",
                { staticClass: "order-box__location-image" },
                [
                  _c("img", {
                    staticClass: "order-box__location-image-element",
                    attrs: {
                      src:
                        _vm.location.image ||
                        _vm.themeImagePath(
                          "location-" + _vm.location.brand + ".jpg"
                        ),
                      alt: _vm.location.brand + " image"
                    }
                  }),
                  _vm._v(" "),
                  _vm.location.brand
                    ? _c(
                        _vm.iconComponent("logo-simple-" + _vm.location.brand),
                        {
                          tag: "component",
                          staticClass: "order-box__location-image-logo",
                          attrs: { alt: _vm.location.brand + " logo" }
                        }
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "order-box__location-content" }, [
            _vm.location.distance
              ? _c("h5", {
                  staticClass: "order-box__location-distance",
                  domProps: { innerHTML: _vm._s(_vm.location.distance) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("h4", {
              staticClass: "order-box__location-name",
              domProps: { innerHTML: _vm._s(_vm.location.name) }
            }),
            _vm._v(" "),
            _vm.location.tags.length
              ? _c(
                  "ul",
                  { staticClass: "order-box__location-tags" },
                  _vm._l(_vm.location.tags, function(tag, index) {
                    return _c("li", {
                      key: index,
                      staticClass: "order-box__location-tag",
                      domProps: { innerHTML: _vm._s(tag) }
                    })
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.shippingMethod == "takeaway" && _vm.location.address
              ? _c(
                  "div",
                  { staticClass: "order-box__location-address" },
                  [
                    _c("SVGLocation", {
                      staticClass: "order-box__location-address-icon"
                    }),
                    _vm._v(" "),
                    _c("address", {
                      staticClass: "order-box__location-address-text",
                      domProps: { innerHTML: _vm._s(_vm.formattedAddress) }
                    })
                  ],
                  1
                )
              : _c("ul", { staticClass: "order-box__location-infos" }, [
                  _vm.location.deliveryTime
                    ? _c(
                        "li",
                        { staticClass: "order-box__location-info" },
                        [
                          _c("SVGClock", {
                            staticClass: "order-box__location-info-icon"
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "order-box__location-info-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("orderbox.locations.deliveryTime", {
                                  minutes: _vm.location.deliveryTime
                                })
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.location.minDeliveryAmount
                    ? _c(
                        "li",
                        {
                          staticClass:
                            "order-box__location-info order-box__location-info--inline"
                        },
                        [
                          _c("SVGBag", {
                            staticClass: "order-box__location-info-icon"
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "order-box__location-info-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("orderbox.locations.minDeliveryAmount", {
                                  amount: _vm.$options.filters.fwgpricecent(
                                    _vm.location.minDeliveryAmount * 100,
                                    "html"
                                  )
                                })
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.location.deliveryPrice
                    ? _c(
                        "li",
                        {
                          staticClass:
                            "order-box__location-info order-box__location-info--inline"
                        },
                        [
                          _c("SVGDelivery", {
                            staticClass: "order-box__location-info-icon"
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "order-box__location-info-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.fwgpricecent(
                                  _vm.location.deliveryPrice * 100,
                                  "html"
                                )
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }